import { BaseComponent } from "utils/base-component"
import readMore from "utils/read-more"

type UnitSystem = "i" | "m"
type ContainerDatasetFlag = "forecastTextSummaryContainer" | "regionTextSummaryContainer"
type UrlDatasetKey = "forecastTextSummaryUrl" | "regionTextSummaryUrl"

type UnitsConv = {
  currentUnits?: UnitSystem
}

declare global {
  interface Window {
    unitsConv?: UnitsConv
  }
}

function currentUnits(): UnitSystem {
  if (window.unitsConv?.currentUnits) return window.unitsConv.currentUnits
  if (document.body.classList.contains("current-units-i")) return "i"
  if (document.body.classList.contains("current-units-m")) return "m"

  return document.body.classList.contains("js-units-i") ? "i" : "m"
}

function initReadMore(root: ParentNode) {
  Array.from(root.querySelectorAll("[data-read-more]")).forEach((el) => readMore(el as HTMLElement))
}

export abstract class TextSummaryBase extends BaseComponent {
  protected abstract readonly containerDatasetFlag: ContainerDatasetFlag
  protected abstract readonly urlDatasetKey: UrlDatasetKey
  private requestSequence = 0

  init() {
    document.addEventListener("switchUnits", () => {
      setTimeout(() => this.updateTextSummary(), 0)
    })
  }

  private updateTextSummary() {
    const units = currentUnits()
    if (this.root.dataset.currentUnits === units) return

    const url = this.root.dataset[this.urlDatasetKey]
    if (!url) return

    this.requestSequence += 1
    const sequence = this.requestSequence
    const separator = url.includes("?") ? "&" : "?"

    fetch(`${url}${separator}units=${encodeURIComponent(units)}`, {
      credentials: "same-origin",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then((response) => response.text())
      .then((html) => {
        if (sequence !== this.requestSequence) return

        if (html.trim() === "") {
          this.remove()
          return
        }

        const replacement = document.createElement("div")
        replacement.innerHTML = html

        const nextContainer =
          Array.from(replacement.children).find(
            (el) => (el as HTMLElement).dataset[this.containerDatasetFlag] !== undefined,
          ) || null
        if (!nextContainer) return

        this.root.replaceWith(nextContainer)
        this.root = nextContainer as HTMLElement
        initReadMore(nextContainer)
      })
      .catch(() => {})
  }
}
